<template>
  <div class="main_contract_part" :class="{is_sub: isSub, ['mode_' + mode]: true, ['state_' + state]: true}" :style="'--level_gap: ' + ((level ?? 0) * 7) + 'px;'">
    <div class="card_b legal_details" :class="{active: part?.isOpen}">
        <div class="head">
            <h3>פרק {{ part.hierarchicalNumber }}: {{ part.title }}</h3>
            <div class="arrow_headers">
                <!-- <div class="rate" v-if="mode=='lawyer'">
                    <span>דרג את הפרק: {{part.rate || 0}}</span>
                    <input type="range" min="0" max="10" v-model="part.rate" @change="$emit('ratePart', part)"  />
                </div> -->
                <template v-if="part?.isOpen && state === 'edit'">
                    <!-- <span >חשיבות הסעיף</span> -->
                    <!-- <span :title="get_word('compensation_clause_info', true)">
                        סעיף תמורה
                        <i class="fas fa-info-circle"></i>
                    </span> -->
                </template> 
                <div class="icon" @click="part.isOpen=!part?.isOpen" :class="part?.isOpen ? 'chevron_up_blue_icon' : 'chevron_down_blue_icon'"></div>
            </div>
        </div>
        <div class="content">
            <div class="parts_container">
                <div class="sub_part" v-for="(subPart) in this.partComp.parts" :key="subPart.id">
                    <contractPart  
                        @addClause="addClause($event, part.id)" 
                        @update="$emit('update', $event)"
                        @addNotePopup="$emit('addNotePopup', $event)"
                        @save_clause="$emit('save_clause', $event)"
                        @save_part="$emit('save_part', $event)"
                        @ratePart="$emit('ratePart', $event)"
                        :state="state"
                        :mode="mode"
                        :index="index"
                        :showIsAprouve="showIsAprouve"
                        :partComp="subPart"  
                        :level="(level ?? 0)+1"
                    />
                </div>
            </div>
            <div class="clauses_container">
                <div class="clause" @mouseenter="clause.edit_mode = true" @mouseleave="clause.edit_mode = false" v-for="clause in clausesComp" :class="{edit_mode: clause.edit_mode || clause.show_note || clause.note?.length > 0, approve: clause?.approve, note_empty: !(clause.note?.length > 0)}" :key="clause.id">
                    <div class="reward-tags" v-if="rewardTags(clause).length > 0">
                      <span class="reward-tag" v-for="(tag, index) in rewardTags(clause)" :key="index" :style="{'background-color': tag.color}">{{ tag.text }}</span>
                    </div>
                    <div class="row">
                        <div class="text_edit_container">
                            <div class="num" v-text="clause.hierarchicalNumber"></div>
                            <div class="text_input_container">
                                <div v-text="clause.content" ></div>
                            </div>
                        </div>
                        <div v-if="state === 'edit' || showIsAprouve" class="approval-control">
                            <TriStateButton 
                                v-model="clause.approve" 
                                @change="clause.note='';saveData(clause)"
                                :disabled="state !== 'edit'"
                            />
                        </div>
                    </div>
                    <div class="row edit_row" v-if="/* (clause.show_note || clause.note?.length > 0) || clause.is_answer */ true">
                        <div class="note_con" v-if="/* (state != 'edit' && clause.note) || state == 'edit' */ true">
                            <div class="title" v-if="!clause.is_answer || state != 'edit'">הערה</div>
                            <div class="title" v-else v-html="get_word('is_reward_title')"></div>
                            <div class="text_input_container" v-if="!clause.is_answer || (clause.is_answer && !clause.is_int)" >
                                <textarea @blur="clause.note_edit=false;saveData(clause)" v-model="clause.note" :disabled="(!clause.note_edit && !clause.is_answer) ||  state != 'edit'" ></textarea>
                            </div>
                            <div class="text_input_container" v-else >
                              <input type="number" min="0" v-model="clause.note" :disabled="(!clause.note_edit && !clause.is_answer) ||  state != 'edit'" />
                            </div>
                        </div> 
                        <div class="trash_btn_container" v-if="state === 'edit' && !clause.is_answer" @click="clause.note = '';clause.note_edit = false;clause.show_note = false;saveData(clause)">
                            <span class="icon trash_icon"></span>
                        </div>
                        <div v-show="!clause.note_edit" v-if="state === 'edit' && !clause.is_answer" class="edit_btn_container btn_b" @click="clause.note_edit = true">
                            <span class="icon edit_b_icon"></span>
                        </div>
                        <!-- <div class="btn_b text_s"  v-if="state === 'edit' && (clause.is_answer && state === 'edit')" v-show="clause.note_edit ||  clause.is_answer" @click="saveData(clause) ;clause.note_edit = false"> שמירה </div> -->
                        
                        <!-- Gallery Input component -->
                        <div class="gallery_input_wrapper">
                            <div v-if="state === 'edit' || ( state !== 'edit' && clause.attachments.length > 0)" class="title">קבצים מצורפים</div>
                            <GalleryInput
                                v-model="clause.attachments"
                                :token="clause.upload_token"
                                :watchOnly="state !== 'edit'"
                            />
                        </div>                
                    </div>
                    <div class="lawyer_notes_con" v-if="clause.notes && clause.notes.length > 0">
                        <div class="title">הערות עורך דין</div>
                        <ul class="notes_con">
                            <li v-for="note in clause.notes" :key="note.id">
                            <div class="note_con">
                                <div class="text_input_container">
                                    <p>{{ note.text }}</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- <div v-if="mode=='lawyer'">
                        <p v-text="clause.lawyer_note"></p>
                        <div class="btn" @click="$emit('addNotePopup', clause.id)">הוספת הערה</div>
                    </div> -->
                </div>
            </div>
            <div class="part_note_container" >
                <div class="note_con">
                    <div class="title">הערה לפרק</div>
                    <div class="text_input_container">
                        <textarea 
                            v-model="part.note" 
                            :disabled="state !== 'edit'"
                            @blur="savePartNote(part.note)"
                            :placeholder="mode == 'lawyer' ? '' : 'הוסף הערה לפרק זה...'"
                        ></textarea>
                    </div>
                </div>
                <div class="trash_btn_container show-unshow" :class="{unshow: state != 'edit' || !part.note}" @click="clearPartNote">
                    <span class="icon trash_icon"></span>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import TriStateButton from '../global/TriStateButton.vue';
import GalleryInput from '../GalleryInput.vue';

export default {
    components: {
        TriStateButton,
        GalleryInput
    },
    props: ['partComp', 'state', 'showIsAprouve', 'dontShowIfNotAprouve', 'index', 'level', 'mode'],
    data() {
        return {
            temp:{points: 1, content: '' , original_content: '', active: true,id: this.random_id(),new: true},
            id: this.random_id(),
            part: this.partComp,
            addClauseInput: '',
            isSub: this.level > 0
        }
    },
    mounted(){
        // console.log(this.part, "s");
            const part = this.part;
            for (let i = 0; i < part.clauses.length; i++) {
                const clause = part.clauses[i];
                if (clause.clause_id == "24919") console.log(clause, "selec ent1", clause.user_id);
                
                if (clause.approve === false) {
                    // sum = sum + 1
                }
            }
        
    },
    watch: {
      part: {
          handler: function (val) {
              this.$emit('update', val);
          },
          deep: true
      }
    },
    methods: {
        saveData(clause) {
            this.$emit('save_clause', clause);
            this.toast(this.get_word('saved_successfully'));
        },
        save() {
            this.$emit('save', this.part);
        },
        random_id() {
            return Math.random().toString(36).substring(2, 12);
        },
        savePartNote() {
            this.$emit('save_part', this.part)
            this.toast(this.get_word('saved_successfully'));
        },
        clearPartNote() {
          this.part.note = '';
          this.$emit('save_part', this.part)
            this.toast(this.get_word('saved_successfully'));
        },
        rewardTags(clause) {
          const ret = [];
          if (+clause.is_answer) {
            ret.push({ text: "יוצג לדיירים בסיכום", color: '#00476c' })
          }
          if (+clause.is_must) {
            ret.push({ text: "תנאי סף להצעה", color: '#a9261d' })
          }
          return ret
        }
    },
    computed: {
        clausesComp() {
            if (this.dontShowIfNotAprouve) {
                return this.part.clauses.filter(item => !item?.approve)
            }
            return this.part.clauses
        },
    }
}
</script>

<style lang="scss" scoped>
.note_btn {
  opacity: 0;
}

.main_contract_part {
  &.state_watch {
    .clauses_container {
      .clause {
        .row { display: flex;
          @include mobile {
            flex-direction: column;
            gap: 8px;
          }
          // display: grid;
          // grid-template-columns: repeat(2, 1fr);
          // grid-template-rows: auto auto;
          // grid-column-gap: 0px;
          // grid-row-gap: 12px;

          // .theme-switch-wrapper { grid-area: 1 / 1 / 2 / 2; }
          // .note_con { grid-area: 1 / 2 / 2 / 3; }
          // .text_edit_container { grid-area: 2 / 1 / 3 / 3; }
        }
        
      }
    }
  }
  &.is_sub {
    & {
      margin-right: var(--level_gap);
    }
    .card_b {
      border-radius: 0;
    }
  }

  &.mode_lawyer {
    .card_b {
      .head {
        @include mobile {
          flex-direction: row !important;
          gap: 8px;padding: 8px !important;
        }
        .arrow_headers {
          .rate { display: flex; align-items: center; gap: var(--gap_small); }
        }
      }
      > .content { padding: 0; }
    }
  }
  .parts_container { display: flex; flex-direction: column;
    .sub_part { padding: var(--gap_small); }
  }
  .clauses_container { display: flex; flex-direction: column;
    .clause {
      & { position: relative; }
      &.approve,
      &:has(.edit_row) {
        .row {
          // .cancel_btn { opacity: 0; pointer-events: none;}
        }
      }
      &:has(.reward-tags) { padding-top: 22px;}
      &:not(:last-child) { border-bottom: 1px solid var(--pageBG); }
      
      .reward-tags { position: absolute; top: 0; display: flex; gap: 10px; padding: 0 32px;
        
        .reward-tag { color: #fff; font-size: 15px; font-weight: 500; padding: 0 10px; padding-bottom: 3px; border-radius: 0 0 10px 10px; display: inline-block; }
      }
      
      .edit_row { padding-top: 0 !important;
        .note_con { flex: 1; display: flex; flex-direction: column; gap: var(--gap_small);
          .title { color: var(--dark_blue); }
        }
        .edit_btn_container { padding: 5px; width: fit-content; aspect-ratio: 1; }
        .trash_btn_container,
        .btn_b { margin-top: calc(1.2em + var(--gap_small)); }
      }
      .row { display: flex; align-items: center; gap: var(--gap_xmid); padding: 20px 32px 20px 64px;

        &.edit_mode { background: #f4f4f5; }
        &:not(.edit_row) { }
        .btn_b { width: fit-content; font-size: var(--h5); }
        
        .approval-control {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 120px;
        }

        .theme-switch-wrapper {
          span { width: 90px; padding-block: 4px; display: flex; align-items: center; justify-content: center; }
          &.active {
            .approve { border-radius: var(--radius_x); color: #067647; background: #ecfdf3; border: 1px solid #0676470a; }
          }
          &:not(.active) {
            .not_approve { border-radius: var(--radius_x); color: #b42318; background: #fef3f2; border: 1px solid #b423180a; }
          }
        }

        .note_con {
            // &:not(.show) { opacity: 0; pointer-events: none; }
            position: relative;
            min-width: 200px;
            
            input {
                width: 100%;
                height: 50px;
                font-size: var(--h5);
                border: 1px solid var(--ligth_color);
            }
            .char-counter {
                position: absolute;
                bottom: 5px;
                left: 5px;
                font-size: 12px;
                color: #666;
                background: transparent;
                pointer-events: none;
                &.near-limit {
                    color: #ff6b6b;
                }
            }
        }

        .cancel_btn { width: 150px; background: transparent; }

        // &:hover {
        //     .text_edit_container {
        //         .edit_btn_container { opacity: 1;}
        //     }
        // }
        &.add_clause { flex-direction: column; align-items: flex-start; gap: var(--gap_small);
          .title {
            p { display: flex; gap: 5px; }
          }
          .fields { width: 100%; display: flex; align-items: center; gap: var(--gap_xmid); }
        }
        .text_edit_container,
        .text_input_container { flex: 1; display: flex; align-items: center; gap: var(--gap);
          .edit_btn_container { cursor: pointer; opacity: 0; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; background: #f4f4f5; border-radius: 50%;
            .icon { width: 60%; height: 60%; }
          }
        }

        .trash_btn_container { cursor: pointer; display: flex; align-items: center; justify-content: center; background: var(--pageBG); width: 36px; height: 36px; border-radius: 8px; }
        .text_input_container { word-break: break-word; border-radius: var(--radius_s); min-height: 2.4em;
          div { line-height: 1.2em; font-size: var(--h5); font-weight: 500; color: var(--dark_blue); }
          input, textarea { padding: 6px; width: 100%; height: 3.6em; line-height: 1.2em; font-size: var(--h5); border: 1px solid var(--ligth_color); }
        }
        > select, .fields select { width: 160px; }
      }
    }
  }
}

.part_note_container {
    padding: 20px 32px;
    display: flex;
    gap: var(--gap_xmid);
    border-top: 1px solid var(--pageBG);

    .note_con {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: var(--gap_small);

        .title {
            color: var(--dark_blue);
        }

        .text_input_container {
            textarea {
                width: 100%;
                min-height: 100px;
                padding: 10px;
                border: 1px solid var(--ligth_color);
                border-radius: var(--radius);
                resize: vertical;
            }
        }
    }

    .trash_btn_container {
        cursor: pointer;
        padding: 5px;
        height: fit-content;
        margin-top: 1.8em;
    }
}

</style>